import NamedDto from 'modules/base/dto/NamedDto';

export class DomainEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.stepCount = null;
		/** @type {string} */
		this.type = null;
		/** @type {string} */
		this.value = null;
		/** @type {string} */
		this.minValue = null;
		/** @type {string} */
		this.maxValue = null;
		/** @type {boolean} */
		this.enabled = null;
	}

	/**
	 * @typedef {Object} _DomainEditDtoProps
	 * @property {number} stepCount
	 * @property {string} type
	 * @property {string} value
	 * @property {string} minValue
	 * @property {string} maxValue
	 * @property {boolean} enabled
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _DomainEditDtoProps} DomainEditDtoProps
	 */
	/**
	 *
	 * @param {DomainEditDtoProps} props
	 * @returns {DomainEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.stepCount = props.stepCount;
		this.type = props.type;
		this.value = props.value;
		this.minValue = props.minValue;
		this.maxValue = props.maxValue;
		this.enabled = props.enabled;

		return this;
	}
}

export default DomainEditDto;
